/**
 * sivalya-custom.js
 * Sivalya.com — Custom theme logic extracted from theme.liquid
 *
 * HOW TO USE AFTER A THEME UPDATE:
 * 1. Upload this file to: Online Store > Themes > Edit code > Assets > Add file
 * 2. In layout/theme.liquid, paste this ONE line just before </body>:
 *    <script src="{{ 'sivalya-custom.js' | asset_url }}" defer></script>
 * 3. That's it - all logic below runs automatically.
 *
 * This file lives in /assets/ and is NOT overwritten by theme updates.
 * Only the one script line in theme.liquid needs to be re-added after an update.
 */
// Fix: update free-shipping bar after any cart add/change from any source (e.g. upsell widgets)
(function() {
  var _fetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) ? init.method.toUpperCase() : 'GET';
    var isCartMutation = method === 'POST' && (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1
    );
    var promise = _fetch.apply(this, arguments);
    if (isCartMutation) {
      promise.then(function() {
        setTimeout(function() {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.dispatchEvent(
                new CustomEvent('cart:updated', { detail: { cart: cart } })
              );
            })
            .catch(function() {});
        }, 300);
      }).catch(function() {});
    }
    return promise;
  };
})();
document.addEventListener('DOMContentLoaded', function () {

  if (document.querySelector('.add-to-cart')) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart');
      if (!btn) return;
      var sel = document.querySelector('.variant-wrapper--dropdown select');
      if (sel && sel.value === '') {
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Please select size';
        btn.disabled = true;
        e.preventDefault();
        return false;
      } else if (sel) {
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Add to cart';
        btn.disabled = false;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.upsell_text-add');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    if (!id) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: '.upsell_text-add' }
        }));
      })
      .catch(function (error) { console.error('Upsell add to cart error:', error); });
  });

  window.giftAdd = function () {
    var giftInput = document.querySelector('#gift-check');
    if (!giftInput) return;
    var id = giftInput.value;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: '.upsell_text-add' }
        }));
      })
      .catch(function (error) { console.error('Gift add to cart error:', error); });
  };

  var code = document.querySelector('#applycode');
  var promo = document.querySelector('#promo-code');
  if (promo) {
    var savedCoupon = localStorage.getItem('coupon');
    if (savedCoupon) { promo.value = savedCoupon; }
  }
  if (code && promo) {
    code.addEventListener('click', function (e) {
      var existing = localStorage.getItem('coupon');
      if (!existing) { localStorage.setItem('coupon', promo.value); }
      e.preventDefault();
    });
  }

  function initLinkedProductsCarousel() {
    if (typeof $ !== 'undefined' && typeof $.fn.slick !== 'undefined') {
      var $carousel = $('.linked-products');
      if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
        $carousel.slick({ infinite: true, slidesToShow: 3, slidesToScroll: 3, arrows: false });
      }
    }
  }

  if (document.body.classList.contains('template-product')) {
    var jqScript = document.createElement('script');
    jqScript.src = '//code.jquery.com/jquery-1.11.0.min.js';
    jqScript.onload = function () {
      var slickScript = document.createElement('script');
      slickScript.src = '//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
      slickScript.onload = initLinkedProductsCarousel;
      document.head.appendChild(slickScript);
    };
    document.head.appendChild(jqScript);
  }

  // Move "Goes well with" (Essential Upsell) to below the accordions
  if (document.body.classList.contains('template-product')) {
    setTimeout(function() {
      var upsellEl = document.querySelector('essential-upsell-cross-sell-app-block');
      var accordions = document.querySelector('.sv-accordions-section');
      if (upsellEl && accordions) {
        // Move only the shopify-app-block wrapper (1 level up), not the whole product block div
        var upsellWrapper = upsellEl.parentElement;
        accordions.parentNode.insertBefore(upsellWrapper, accordions.nextSibling);
      }
    }, 300);
  }

});

/**
 * sivalya-custom.js
 * Sivalya.com — Custom theme logic extracted from theme.liquid
 *
 * HOW TO USE AFTER A THEME UPDATE:
 * 1. Upload this file to: Online Store > Themes > Edit code > Assets > Add file
 * 2. In layout/theme.liquid, paste this ONE line just before </body>:
 *    <script src="{{ 'sivalya-custom.js' | asset_url }}" defer></script>
 * 3. That's it - all logic below runs automatically.
 */
 
// ── Free-shipping bar: update after any cart mutation ──
(function() {
  var _fetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) ? init.method.toUpperCase() : 'GET';
    var isCartMutation = method === 'POST' && (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1
    );
    var promise = _fetch.apply(this, arguments);
    if (isCartMutation) {
      promise.then(function() {
        setTimeout(function() {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            })
            .catch(function() {});
        }, 300);
      }).catch(function() {});
    }
    return promise;
  };
})();
 
document.addEventListener('DOMContentLoaded', function () {
 
  // ── Add to cart: require size selection ──
  if (document.querySelector('.add-to-cart')) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart');
      if (!btn) return;
      var sel = document.querySelector('.variant-wrapper--dropdown select');
      if (sel && sel.value === '') {
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Please select size';
        btn.disabled = true;
        e.preventDefault();
        return false;
      } else if (sel) {
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Add to cart';
        btn.disabled = false;
      }
    });
  }
 
  // ── Upsell add to cart ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.upsell_text-add');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    if (!id) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: '.upsell_text-add' }
        }));
      })
      .catch(function (err) { console.error('Upsell add to cart error:', err); });
  });
 
  // ── Gift add to cart ──
  window.giftAdd = function () {
    var giftInput = document.querySelector('#gift-check');
    if (!giftInput) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: giftInput.value, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: '.upsell_text-add' }
        }));
      })
      .catch(function (err) { console.error('Gift add to cart error:', err); });
  };
 
  // ── Promo code persistence ──
  var code = document.querySelector('#applycode');
  var promo = document.querySelector('#promo-code');
  if (promo) {
    var savedCoupon = localStorage.getItem('coupon');
    if (savedCoupon) { promo.value = savedCoupon; }
  }
  if (code && promo) {
    code.addEventListener('click', function (e) {
      if (!localStorage.getItem('coupon')) { localStorage.setItem('coupon', promo.value); }
      e.preventDefault();
    });
  }
 
  // ── Linked products carousel (PDP) ──
  if (document.body.classList.contains('template-product')) {
    var jqScript = document.createElement('script');
    jqScript.src = '//code.jquery.com/jquery-1.11.0.min.js';
    jqScript.onload = function () {
      var slickScript = document.createElement('script');
      slickScript.src = '//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
      slickScript.onload = function () {
        if (typeof $ !== 'undefined' && typeof $.fn.slick !== 'undefined') {
          var $c = $('.linked-products');
          if ($c.length && !$c.hasClass('slick-initialized')) {
            $c.slick({ infinite: true, slidesToShow: 3, slidesToScroll: 3, arrows: false });
          }
        }
      };
      document.head.appendChild(slickScript);
    };
    document.head.appendChild(jqScript);
  }
 
  // ── Move Essential Upsell below accordions (PDP) ──
  if (document.body.classList.contains('template-product')) {
    setTimeout(function() {
      var upsellEl = document.querySelector('essential-upsell-cross-sell-app-block');
      var accordions = document.querySelector('.sv-accordions-section');
      if (upsellEl && accordions) {
        accordions.parentNode.insertBefore(upsellEl.parentElement, accordions.nextSibling);
      }
    }, 300);
  }
 
});
 
// ── Collection filter bar: custom sort dropdown ──
(function () {
  'use strict';
 
  function initSortDropdown() {
    var container = document.querySelector('.collection-filter__sort-container');
    if (!container) return;
    var select = container.querySelector('#SortBy, select[name="SortBy"]');
    if (!select) return;
 
    // Remove stale UI
    var old = container.querySelector('.sv-sort-trigger');
    if (old) old.remove();
    var oldPanel = container.querySelector('.sv-sort-panel');
    if (oldPanel) oldPanel.remove();
 
    // Dedupe options (Impulse adds a duplicate title-ascending)
    var allOpts = Array.from(select.options);
    var renderOpts = allOpts.filter(function (opt, i) {
      return !allOpts.slice(i + 1).some(function (o) { return o.value === opt.value; });
    });
 
    // Current selection label
    var currentVal = select.value;
    var currentText = '';
    renderOpts.forEach(function (o) { if (o.value === currentVal) currentText = o.text.trim(); });
    if (!currentText) currentText = renderOpts[0] ? renderOpts[0].text.trim() : '';
 
    // Build trigger
    var trigger = document.createElement('button');
    trigger.className = 'sv-sort-trigger';
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
 
    var lbl = document.createElement('span');
    lbl.className = 'sv-sort-trigger__label';
    lbl.textContent = 'Sort by:';
 
    var val = document.createElement('span');
    val.className = 'sv-sort-trigger__value';
    val.textContent = currentText;
 
    var caret = document.createElement('span');
    caret.className = 'sv-sort-trigger__caret';
    caret.setAttribute('aria-hidden', 'true');
    caret.textContent = '▾';
 
    trigger.appendChild(lbl);
    trigger.appendChild(val);
    trigger.appendChild(caret);
 
    // Build panel
    var panel = document.createElement('ul');
    panel.className = 'sv-sort-panel';
    panel.setAttribute('role', 'listbox');
 
    renderOpts.forEach(function (opt) {
      var li = document.createElement('li');
      li.className = 'sv-sort-panel__option' + (opt.value === currentVal ? ' is-selected' : '');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', opt.value === currentVal ? 'true' : 'false');
      li.dataset.value = opt.value;
      li.textContent = opt.text.trim();
      panel.appendChild(li);
    });
 
    container.appendChild(trigger);
    container.appendChild(panel);
 
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = panel.classList.contains('is-open');
      closeAll();
      if (!isOpen) { panel.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    });
 
    panel.addEventListener('click', function (e) {
      var li = e.target.closest('.sv-sort-panel__option');
      if (!li) return;
      panel.querySelectorAll('.sv-sort-panel__option').forEach(function (o) {
        o.classList.remove('is-selected'); o.setAttribute('aria-selected', 'false');
      });
      li.classList.add('is-selected'); li.setAttribute('aria-selected', 'true');
      val.textContent = li.textContent.replace(/^— /, '').trim();
      closeAll();
      select.value = li.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
 
  function closeAll() {
    document.querySelectorAll('.sv-sort-panel').forEach(function (p) { p.classList.remove('is-open'); });
    document.querySelectorAll('.sv-sort-trigger').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }
 
  document.addEventListener('click', closeAll);
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortDropdown);
  } else { initSortDropdown(); }
 
  ['ajaxCollection:loaded', 'collection:reloaded'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(initSortDropdown, 80); });
  });
 
  function attachObserver() {
    var root = document.getElementById('CollectionAjaxContent') || document.querySelector('.collection-content');
    if (!root) return;
    new MutationObserver(function (m) {
      if (m.some(function (r) { return r.addedNodes.length > 0; })) setTimeout(initSortDropdown, 80);
    }).observe(root, { childList: true, subtree: false });
  }
 
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', attachObserver); }
  else { attachObserver(); }
 
})();